import React from "react";
import icon from "../../../asset/trophy-svgrepo-com.svg";

const LeaderboardThirdTrader = ({  profile_pics, username, points, rank }) => {
  return (
    <div className="leaderboard__list__section leaderboardmobile__list">
      <div className="leaderboardmobile__list__section__image ">
        <img src={profile_pics} alt="" className="leaderboard__list__section__img" />
        <p className="leaderboard__span">{rank}</p>
      </div>
      <div className="leaderboard__list__section__text">
        <p className="leaderboardmobile__list__first__text">{username}</p>
        <div className="leaderboard__list__section__section">
          <p className="leaderboardmobile__list__second__text">{points}</p>
          <div className="leaderboardmobile__list__section__section__image">
            <img src={icon} alt=""  />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeaderboardThirdTrader;